import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { compose, withHandlers } from 'recompose';
import { bindActionCreators, Dispatch } from 'redux';
import { goBack as goBackAction, push } from 'redux-first-history';

import { RootState } from '@store/reducers';
import { appRedirectConfig } from '@routes/appRoutesConfig';

export interface WithNavigation extends RouteComponentProps<any> {
  goBack: () => void;
  goTo: typeof push;
  goHome: () => void;
}

interface WithNavigationPrivateProps
  extends ReturnType<typeof mapDispatchToProps>,
    ReturnType<typeof mapStateToProps> {}

const mapStateToProps = (state: RootState) => ({
  location: state.router.location.pathname,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      goToAction: push,
      goBack: goBackAction,
    },
    dispatch,
  );

function withNavigation(Comp: React.FunctionComponent<{ children?: React.ReactNode }>) {
  class WrappedComponent extends React.Component {
    public render() {
      return <Comp {...this.props} />;
    }
  }

  return compose(
    withRouter,
    connect(
      mapStateToProps,
      mapDispatchToProps,
    ),
    withHandlers({
      goTo: ({ goToAction }: WithNavigationPrivateProps) => (path) => {
        goToAction(path);
      },
      goHome: ({ goToAction }: WithNavigationPrivateProps) => () => {
        goToAction(appRedirectConfig.to);
      },
    }),
  )(WrappedComponent);
}

export default withNavigation;
